import FJAIAudioLeftContainer from './FJAIAudioLeft/container/FJAIAudioLeftContainer.jsx';
import FJAIAudioRightContainer from './FJAIAudioRight/container/FJAIAudioRightContainer.jsx';

function FJAIAudio() {
    return (
        <>
            <FJAIAudioLeftContainer />
            <FJAIAudioRightContainer />
        </>
    );
}

export default FJAIAudio;
